import { render, staticRenderFns } from "./productWarehouse.vue?vue&type=template&id=677a0974&"
import script from "./productWarehouse.vue?vue&type=script&lang=js&"
export * from "./productWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./productWarehouse.vue?vue&type=style&index=0&id=677a0974&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports